import {gql} from '@apollo/client';

export const CHECK_CODE = gql`
    mutation checkGetMoneyWwCode ($data: CheckGetMoneyWwCodeInput!, $session: String) {
        checkGetMoneyWwCode(data: $data, session: $session) {
            FIO
            token
            paid
        }
    }
`